import { initDeferredFormResources } from '@helpers/deferredFormResources';

initDeferredFormResources();
